
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import {mapGetters} from 'vuex'

export default{
computed: {

headShow() {
return this.$store.getters.headShow;
},
loading() {
return this.$store.getters.loading;
},
footerShow() {
return this.$store.getters.footerShow;
},
pageTitle() {
return this.$store.getters.pageTitle;
},
},
components: {
Tabbar,
TabbarItem,
XHeader,
Loading,
ViewBox,
Icon
},
data(){
return{
name:'',
tel:'',
taskname: '',
totalData: [],
uploader: [],
uploader2: [],
uploader3: [],
uploader4: [],
notes: '',
value: '',
value2: '',
showPicker: '',
columns: [],
filenames2:[],
filenames22:[],
filenames222:[],
filenames2222:[],
paths:[]
}
},
mounted(){
this.$store.commit('UPDATE_PAGE_TITLE', '任务提交')
this.showPicker   = this.$route.params.titles
this.value2 = this.$route.params.id

},
methods:{




subConfirm(){

console.log(this.uploader[0])









var time =  this.gettime()
console.log(time)
this.renwutijiao(time)

},
doPage(wxid) {
this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid+'&status='+ "未完成" ,).then(res => res.data).then(res => {
console.log(res)
this.totalData = res.rows
this.totalData.forEach((item)=>{
console.log(item.title)
this.$set(this.columns, this.columns.length, item.title);
})

})

},

renwutijiao(time){

this.$axios
.post(this.$httpUrl + "/daren/external_personwork", {
id: '',
name: this.name,
likedfile: this.filenames2.join(','),
commentfile: this.filenames22.join(','),
transmitfile: this.filenames222.join(','),
watchingfile: this.filenames2222.join(','),
phone: this.tel,
workUnit: this.notes

})
.then((res) => res.data)
.then((res) => {
console.log(res);

if(res.code === 200){
this.$router.push('/shouye')
}else{
alert("提交失败")
}


});
},
afterRead(files, detail) {
console.log("handle");
console.log(files.file);
files.content = files.content.replace('data:application/octet-stream;', `data:image/png;`);
this.filedata = 1
let base = files.content
let name = files.name
console.log(base)
console.log(name)
this.handle( this.base64ToFile(base,name))

},
afterRead2(files, detail) {
console.log("handle2");
console.log(files.file);
files.content = files.content.replace('data:application/octet-stream;', `data:image/png;`);
console.log(files.file);
this.filedata = 1
let base = files.content
let name = files.name
console.log(base)
console.log(name)
this.handle2( this.base64ToFile(base,name))

},
afterRead3(files, detail) {
console.log("handle3");
console.log(files.file);
files.content = files.content.replace('data:application/octet-stream;', `data:image/png;`);
console.log(files.content)
this.filedata = 1
let base = files.content
let name = files.name
console.log(base)
console.log(name)

this.handle3( this.base64ToFile(base,name))

},
afterRead4(files, detail) {
console.log("handle4");
console.log(files.file);
files.content = files.content.replace('data:application/octet-stream;', `data:image/png;`);
this.filedata = 1
let base = files.content
let name = files.name
console.log(base)
console.log(name)


this.handle4( this.base64ToFile(base,name))

},
base64ToFile(base64Data, filename) {

const arr = base64Data.split(',');
const mime = arr[0].match(/:(.*?);/)[1];
const bstr = atob(arr[1]);
let n = bstr.length;
const u8arr = new Uint8Array(n);

while (n--) {
u8arr[n] = bstr.charCodeAt(n);
}


const blob = new Blob([u8arr], { type: mime });


const file = new File([blob], filename, { type: mime });

return file;
},

handle(file) {


var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path)
this.$set( this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222)
console.log(res.fileName)
this.filenames2.push(res.fileName)

} else {

}
});





},
handle2(file) {


var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path)
this.$set( this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222)
console.log(res.fileName)
this.filenames22.push(res.fileName)

} else {

}
});





},
handle3(file) {


var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path)
this.$set( this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222)
console.log(res.fileName)
this.filenames222.push(res.fileName)

} else {

}
});





},
handle4(file) {


var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path)
this.$set( this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222)
console.log(res.fileName)
this.filenames2222.push(res.fileName)

} else {

}
});





},


gettime(){
console.log("im coming")
var day = new Date();
console.log(day)
let seconds = day.getSeconds();
if (seconds < 10) { // 如果月份值小于10，则在前面加上0
seconds = "0" + seconds;
} else {
seconds = seconds;
}
let minutes = day.getMinutes();
if (minutes < 10) {
minutes = "0" + minutes;
} else {
minutes = minutes;
}
let month = day.getMonth()
if (month < 10) {
month = "0" + month;
}
let time = day.getFullYear() + "-" + (day.getMonth() + 1) + "-" + day.getDate() + " " + day.getHours() + ":" + minutes + ":"     + seconds;
return time


},
}
}



// WEBPACK FOOTER //
// ./src/views/Ttaskwai.vue